import GroupCalculation from "../components/GroupCalculation";
import useGroupCalculation from "../hook/useGroupCalculation";

function GroupCalculationPage() {
    const props = useGroupCalculation();
    return <GroupCalculation {...props} />
}
export default GroupCalculationPage